import React from 'react';
import '../../styles/cfq.css';

/** "CFQ2026/64", with the number standing out and cancelled ones struck through. */
export const Reference = ({ request }) => (
  <span className={`cfq-ref${request.status === 'cancelled' ? ' cfq-ref--cancelled' : ''}`}>
    <span className="cfq-ref__year">CFQ{request.year}/</span>
    <span className="cfq-ref__num">{request.number}</span>
  </span>
);

const STATUS_LABELS = { open: 'Open', closed: 'Closed', cancelled: 'Cancelled' };

export const STATUS_OPTIONS = Object.entries(STATUS_LABELS).map(([value, label]) => ({ value, label }));

export const StatusBadge = ({ status }) => <span className={`cfq-status cfq-status--${status}`}>{STATUS_LABELS[status]}</span>;
